import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 24px;
`;
export const QuestionRow = styled.div`
  display: flex;
  align-items: center;
`;
export const AnswersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;
